import { call, put, takeLatest, all } from 'redux-saga/effects';
import { stopSubmit } from 'redux-form';

import { actions } from 'store/testReducer';
import { setPaginationFor } from 'store/pagination-reducer';
import api from 'core/utils/api';
import * as notify from 'components/ui/Notify/store/actions';

const setTestsPagination = setPaginationFor('TESTS');

function* fetchTests(action) {
  const params = action.payload;
  try {
    const res = yield call(api.get, '/tests', { params });
    yield put(actions.fetchTestsSuccess(res.data.tests));
    yield put(setTestsPagination(res));
  } catch(err) {
    yield put(actions.fetchTestsFail(err.response.data.error));
  }
}

function* watchFetchTests() {
  yield takeLatest(actions.fetchTests().type, fetchTests);
}

function* fetchTest(action) {
  try {
    const res = yield call(api.get, `/tests/${action.payload}`);
    yield put(actions.fetchTestSuccess(res.data.test));
  } catch(err) {
    yield put(actions.fetchTestFail(err.response.data.error));
  }
}

function* watchFetchTest() {
  yield takeLatest(actions.fetchTest().type, fetchTest)
}

function* createTest(action) {
  try {
    const res = yield call(api.post, '/tests', { test: action.payload[0] });
    yield put(actions.createTestSuccess(res.data.test));
    yield put(notify.actions.success('Test was successfully created.'));
    yield call(action.payload[1]);
  } catch(err) {
    yield put(actions.createTestFail(err.response.data.error));
    yield put(stopSubmit('test', err.response.data.error.message));
  }
};

function* watchCreateTest() {
  yield takeLatest(actions.createTest().type, createTest)
};

function* updateTest(action) {
  const test = action.payload[0];
  try {
    const res = yield call(api.put, `/tests/${test.id}`, { test });
    yield put(actions.updateTestSuccess(res.data.test));
    yield put(notify.actions.success('Test was successfully updated.'));
    yield call(action.payload[1]);
  } catch(err) {
    yield put(actions.updateTestFail(err.response.data.error));
    yield put(stopSubmit('test', err.response.data.error.message));
  }
}

function* watchUpdateTest() {
  yield takeLatest(actions.updateTest().type, updateTest);
}

function* deleteTest(action) {
  try {
    const res = yield call(api.delete, `/tests/${action.payload}`);
    yield put(actions.deleteTestSuccess(res.data.test));
    yield put(notify.actions.success('Test was successfully deleted.'));
  } catch(err) {
    const { error } = err.response.data;
    yield put(actions.deleteTestFail(error));
    yield put(notify.actions.error(error.message));
  }
}

function* watchDeleteTest() {
  yield takeLatest(actions.deleteTest().type, deleteTest);
}

export default function* testsSaga() {
  yield all([
    watchFetchTests(),
    watchFetchTest(),
    watchCreateTest(),
    watchUpdateTest(),
    watchDeleteTest(),
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/testsSaga.js